export function normalizeAskAiSseVersion(raw: unknown): string {
  const version = typeof raw === 'string' ? raw.trim() : '';
  return version.length > 0 ? version : 'latest';
}

export function supportsAskAiSseResponseMode(raw: unknown): boolean {
  const version = normalizeAskAiSseVersion(raw).toLowerCase();
  return version === 'gen2' || version === 'latest';
}
